import { JourneyEvent } from '../../idscan/enums/JourneyEvent';
import EventService from './EventService';

/**
 * @internal
 */
export namespace ExceptionManager {
	/**
	 * @internal
	 */
	export function process(exception: Exception): Exception {
		EventService.publish(JourneyEvent.ERROR, { exception });

		return exception;
	}

	/**
	 * @internal
	 */
	export class Exception extends Error {
		public timestamp: number;
		public response: any;

		/**
		 * @class Exception
		 * @param message
		 * @param name
		 * @param response
		 */
		constructor(message: string, name: string = 'Exception', response?: any | undefined) {
			super(message);

			this.name = name;
			this.response = response;
			this.timestamp = Date.now();
		}
	}

	/**
	 * class NetworkException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class NetworkException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'NetworkException', response);
		}
	}

	/**
	 * class ServerException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class ServerException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'ServerException', response);
		}
	}

	/**
	 * class BadRequestException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class BadRequestException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'BadRequestException', response);
		}
	}

	/**
	 * class AuthorizationException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class AuthorizationException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'AuthorizationException', response);
		}
	}

	/**
	 * class MissingParameterException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class MissingParameterException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'MissingParameterException', response);
		}
	}

	/**
	 * class PlatformException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class PlatformException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'PlatformException', response);
		}
	}

	/**
	 * class NotFoundException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class NotFoundException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'NotFoundException', response);
		}
	}

	/**
	 * class FlowStateException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class FlowStateException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'FlowStateException', response);
		}
	}

	/**
	 * class InvalidParameterException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class InvalidParameterException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'InvalidParameterException', response);
		}
	}

	/**
	 * class UnavailableInputProviderException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class UnavailableInputProviderException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'UnavailableInputProviderException', response);
		}
	}

	/**
	 * class WebSocketException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class WebSocketException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'WebSocketException', response);
		}
	}

	/**
	 * class WebSocketException extends Exception
	 * @param response
	 * @param message
	 *
	 * @internal
	 */
	export class TemplateException extends Exception {
		constructor(message: string, response?: any) {
			super(message, 'TemplateException', response);
		}
	}
}
